// import classnames from 'classnames';
import React, {useState} from 'react';
import * as PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import {useDesktopMediaQuery} from 'Utils/ResponsiveUtil';

const useStyles = makeStyles(() => ({
    button: {
        height: 41,
        margin: '8px 8px 0px 8px',
    },
    expandButton: {
        display: 'flex',
        width: 262,
        margin: '8px 8px 20px 8px',
    },
    labelContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        maxWidth: '100%',
        marginRight: 10,
    },
    buttonLabel: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        WebkitLineClamp: 2,
        lineHeight: 1,
        textOverflow: 'ellipsis',
        marginTop: 2,
    },
    expandIcon: {
        position: 'absolute',
        right: 12,
    },
    menu: {
        background: '#5B5B5B',
        borderRadius: 8,
        paddingBottom: 8,
        maxHeight: '25vh',
        overflowY: 'scroll',
        '& button:first-child': {
            marginBottom: 10,
            '&:after': {
                content: '""',
                borderBottom: '1px solid #FFFFFF4D',
                width: '100%',
                position: 'absolute',
                bottom: '-9px',
            },
        },
    },
    menuButton: {
        width: props => (props.isFullWidthButtons ? null : 262),
    },
    expandedMenu: props => ({
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '90vh',
        ...(props.isDesktop && {
            position: 'absolute',
            top: 16,
            right: 16,
        }),
        ...(!props.isDesktop && {
            top: 0,
            absolute: '100%',
        }),
    }),
}));

const ClientSwitcher = props => {
    const isDesktop = useDesktopMediaQuery();
    const classes = useStyles({
        isDesktop,
        isFullWidthButtons: !isDesktop && props.isAlwaysExpanded,
    });
    const [isExpanded, setExpanded] = useState(props.isAlwaysExpanded);
    const selectedClient = props.clientList.find(client => client.id === props.selectedClientId);

    return (
        <>
            {!isExpanded && (
                <>
                    {props.isVisible &&
                        props.clientList.length > 1 && (
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classNames(classes.button, classes.expandButton)}
                                onClick={() => setExpanded(true)}
                            >
                                <div className={classes.labelContainer}>
                                    <span className={classes.buttonLabel}>
                                        {selectedClient ? selectedClient.name : null}
                                    </span>
                                </div>
                                <svg
                                    className={classes.expandIcon}
                                    width="13"
                                    height="13"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.7024 4.38664L9.68431 5.3L6.37011 2.3332L3.05591 5.3L2.03782 4.38664L6.37011 0.500004L10.7024 4.38664Z"
                                        fill="#303030"
                                    />
                                    <path
                                        d="M2.0379 8.41336L3.05599 7.5L6.37019 10.4668L9.68438 7.5L10.7025 8.41336L6.37019 12.3L2.0379 8.41336Z"
                                        fill="#303030"
                                    />
                                </svg>
                            </Button>
                        )}
                    {props.children}
                </>
            )}
            {isExpanded && (
                <div
                    className={classNames(classes.menu, {
                        [classes.expandedMenu]: props.isAlwaysExpanded,
                    })}
                >
                    {props.clientList.map(client => (
                        <Button
                            key={client.id}
                            variant="contained"
                            color={client.id === props.selectedClientId ? 'primary' : 'secondary'}
                            className={classNames(classes.button, classes.menuButton)}
                            classes={{
                                label: classes.buttonLabel,
                            }}
                            onClick={() => {
                                if (client.id === props.selectedClientId) {
                                    setExpanded(false);
                                }
                                props.onClick(client);
                            }}
                        >
                            {client.name}
                        </Button>
                    ))}
                </div>
            )}
        </>
    );
};

ClientSwitcher.defaultProps = {
    isAlwaysExpanded: false,
    isVisible: true,
    clientList: [],
};

ClientSwitcher.propTypes = {
    isAlwaysExpanded: PropTypes.bool,
    clientList: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            navMapId: PropTypes.string,
        })
    ),
    selectedClientId: PropTypes.string,
    onClick: PropTypes.func,
    isVisible: PropTypes.bool,
    children: PropTypes.any,
};

export default ClientSwitcher;
